let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fTFcV"), load("a0ybh"), load("aoJPa")]).then(() => parcelRequire('kaQDe'));